<template>
  <div>
    <header v-if="shouldRenderMobileHeader">
      <div class="layout-with-centered-max-width-child">
        <div>
          <div class="header-margin-top-bottom">
            <div class="pure-g">
              <div class="pure-u-1-3">
                <div>
                  <div class="mobile-hamburger-container">
                    <div>
                      <HeaderMobileDropdown>
                        <div>
                          <Fai :icon="['fas', 'bars']"/>
                        </div>
                      </HeaderMobileDropdown>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pure-u-1-3">
                <div class="logo-container">
                  <div>
                    <img src="../../assets/images/bigmind-logo.png" alt="Bigmi Logo">
                  </div>
                </div>
              </div>
              <div class="pure-u-1-3">
                <div>
                  <div class="mobile-login-container">
                    <div v-if="!isLoggedIn">
                      <LoginDropdown>
                        <div class="login-area font-primary">
                          <div class="login">
                            <span>Login</span>
                          </div>
                        </div>
                      </LoginDropdown>
                    </div>
                    <div v-else>
                      <div class="profile-area font-primary">
                        <div>
                          <UserDropdown>
                            <div class="login">
                              <span>{{profileDropdownText}}</span>
                            </div>
                          </UserDropdown>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <header v-else>
      <div class="layout-with-centered-max-width-child">
        <div>
          <div class="header-margin-top-bottom">
            <div class="pure-g">
              <div class="pure-u-1-3">
                <div class="download-wrapper">
                  <div class="download-our-app font-primary">
                    <span>DOWNLOAD OUR APP</span>
                  </div>
                  <div class="download-images">
                    <a :href="googlePlaystoreLink" target="_blank">
                      <div class="store-link-img-container">
                        <img src="../../assets/images/google-play.png" alt="Google Play">
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="pure-u-1-3">
                <div class="logo-container">
                  <div>
                    <img src="../../assets/images/bigmind-logo.png" alt="Bigmi Logo">
                  </div>
                </div>
              </div>
              <div class="pure-u-1-3">
                <div>
                  <div>
                    <div class="rows">
                      <div class="profile-row">
                        <div>
                          <div v-if="!isLoggedIn">
                            <LoginDropdown>
                              <div class="login-area font-primary">
                                <div>
                                  <Fai :icon="['fas', 'user']"/>
                                </div>
                                <div class="login">
                                  <span>Login</span>
                                </div>
                              </div>
                            </LoginDropdown>
                          </div>
                          <div v-else>
                            <div class="profile-area font-primary">
                              <div>
                                <UserDropdown>
                                  <div>
                                    <Fai :icon="['fas', 'user']"/>
                                  </div>
                                  <div class="login">
                                    <span>{{profileDropdownText}}</span>
                                  </div>
                                </UserDropdown>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="search-row">
                        <form class="pure-form" @submit.prevent="handleSubmit">
                          <input v-model="searchQuery" type="text" placeholder="Search">
                          <button type="submit" class="pure-button flat-button">
                            <Fai :icon="['far', 'search']"/>
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout-with-centered-max-width-child">
        <div class="nav-row no-max">
          <div v-for="(navObj, i) of navItems" :key="i">
            <div>
              <div class="nav-link-router-link-container">
                <router-link v-if=navObj.shouldNavigate :to="navObj.route">{{navObj.ui.name}}</router-link>
                <div class="still-a-button" v-else v-on:click="openLoginDropdown(navObj.route)">{{navObj.ui.name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div v-if="emailConfirmationShowState">
      <Modal>
        <div class="confirm-delete-study-dialog pdng-1">
          <div>
            <div class="exit-row">
              <span class="logout-button" @click="signout()">
                <Fai :icon="['fas', 'sign-out']"/>
                <span style="padding: 0 1em 0 0.5em;">LOGOUT</span>
              </span>
            </div>
            <div class="pdng-1">
              <div class="prompt-row">
                <div class="header font-secondary">Thank you</div>
                <span>We've sent a welcome email to the address you used to register.  After you've openen the link in the email, come back here and press continue to move forward</span>
              </div>
              <div class="actions-row pdng-1 top">
                <div class="action">
                  <button type="button" class="pure-button bigmi-wide-button bigmi-cyan-blue-2-button"
                          @click="continueToNextPage()">
                    <span>CONTINUE</span>
                  </button>
                </div>
                <div class="action">
                  <span v-if="emailSending">
                            <Loading></Loading>
                        </span>
                  <button v-else type="button" class="pure-button bigmi-wide-button bigmi-cyan-blue-2-button"
                          @click="resendEmail()"
                          :disabled="!emailPristine">
                    <span v-if="emailPristine">RESEND EMAIL</span>
                    <span v-if="emailSent">SENT</span>
                    <span v-else-if="emailFailedToSend">FAILED TO SEND.  TRY AGAIN</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {HeaderMobileDropdownAsync} from "./HeaderMobileDropdownAsync"
  import {UserDropdownAsync} from './UserDropdownAsync'

  const LoginDropdownAsync = () => import(/* webpackChunkName: "public-group" */'./LoginDropdown')
  import {
    GET_IS_MOBILE_VIEWPORT,
    GET_NAV_ROUTES,
    GET_PROFILE_DROPDOWN_TEXT,
    GET_IS_LOGGED_IN,
    R_NAME_BROWSE,
    SET_LOGIN_DROPDOWN_STATE,
    LOAD_USER,
    RESEND_CONFIRMATION_EMAIL,
    LOADING_PRISTINE,
    LOADING_STARTED,
    LOADING_COMPLETED_SUCCESS,
    LOADING_COMPLETED_FAILURE, LOGOUT, R_NAME_HOME, SET_LOGIN_REDIRECT,
  } from "@/services/constants"
  import {loggerMixin} from '@/mixins/logger'

  export default {
    name: 'Header',
    mixins: [loggerMixin],
    components: {
      'HeaderMobileDropdown': HeaderMobileDropdownAsync,
      'LoginDropdown': LoginDropdownAsync,
      'UserDropdown': UserDropdownAsync,
    },

    data(){
      return{
        searchQuery: '',
      }
    },
    computed: {
      ...mapGetters([
        GET_IS_MOBILE_VIEWPORT,
        GET_NAV_ROUTES,
        GET_PROFILE_DROPDOWN_TEXT,
        GET_IS_LOGGED_IN,
      ]),
      navItems() {
        return this[GET_NAV_ROUTES].map( obj => {
          let shouldNavigate = true
          if(obj.ui.name === 'DASHBOARD' || obj.ui.name === 'CREATE'){
            if(!this.isLoggedIn){
              shouldNavigate = false
            }
          }
          return Object.assign({}, obj, {'shouldNavigate': shouldNavigate})
        })
      },
      shouldRenderMobileHeader() {
        return this[GET_IS_MOBILE_VIEWPORT]
      },
      isLoggedIn() {
        return this.$store.getters[GET_IS_LOGGED_IN]
      },
      profileDropdownText() {
        return this[GET_PROFILE_DROPDOWN_TEXT]
      },
      emailConfirmationShowState(){
        return this.$store.state.userModule.emailConfirmationShowState
      },
      emailPristine(){
        return this.$store.state.userModule.resendEmailState === LOADING_PRISTINE
      },
      emailSending(){
        return this.$store.state.userModule.resendEmailState === LOADING_STARTED
      },
      emailSent(){
        return this.$store.state.userModule.resendEmailState === LOADING_COMPLETED_SUCCESS
      },
      emailFailedToSend(){
        return this.$store.state.userModule.resendEmailState === LOADING_COMPLETED_FAILURE
      },
      googlePlaystoreLink(){
        return "https://play.google.com/store/apps/details?id=net.ideamap.android"
      }

    },
    methods: {
      handleSubmit() {
        this.$router.push({
          name: R_NAME_BROWSE,
          query: { q: this.searchQuery }
        });
        this.searchQuery = ''
      },
      openLoginDropdown(redirectRoute){
        this.$store.commit(SET_LOGIN_REDIRECT, redirectRoute)
        this.$store.commit(SET_LOGIN_DROPDOWN_STATE, true)
      },
      continueToNextPage(){
        this.$store.dispatch(LOAD_USER)
      },
      resendEmail(){
        this.$store.dispatch(RESEND_CONFIRMATION_EMAIL)
      },
      signout(){
        this.$store.dispatch(LOGOUT)
          .then(() => {
            this.$router.push({name: R_NAME_HOME})
          })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";

  header {
    height: $header-height;
    @media #{$mobile} {
      height: $header-height-mobile;
    }
    color: $red-2;
    max-width: 1024px;
    text-align: center;
    margin: auto;

    .mobile-hamburger-container {
      color: $cyan-blue-3;
      margin: 0 0 0 .5em;
      font-size: 150%;
    }

    .header-margin-top-bottom {
      margin: 1.5em 0 2em;
      @media #{$mobile} {
        margin: 1em 0;
      }
    }

    .download-wrapper {
      margin: 0 0 0 1em;
    }

    .logo-container {
      display: flex;
      justify-content: center;
      > div {
        width: 108px;
        height: 100px;
        > img {
          width: 100%;
          height: auto;
        }
      }
    }

    .rows {
      color: $cyan-blue-3;
      .profile-row {
        display: flex;
        justify-content: flex-end;
        margin: 0 0 20px 0;
        padding: 0 0 0 1em;

        .login {
          color: $red-2;
          margin: 0 0 10px 10px;
          padding: 0 1em 0 0;
          text-transform: uppercase;

        }

        .cart-icon-container {
          margin: 0 2em 0 0;
        }
      }
    }

    .mobile-login-container {
      display: flex;
      margin: 0;
      justify-content: flex-end;
      .login {
        color: $red-2;
        margin: 0 0 10px 0;
        padding: 0 1em 0 0;
      }
    }

    .login-area {
      display: flex;
      cursor: pointer;
    }

    .profile-area {
      display: flex;
      cursor: default;
    }

    .nav-row {
      display: flex;
      justify-content: center;
      background-color: $cyan-blue-3;
    }

    .nav-link-router-link-container {
      padding: 1em;
    }

    .still-a-button{
      color: white;
      cursor: pointer;
    }

  }

  .confirm-delete-study-dialog {
    background-color: $white-1;
    border-radius: 5px;

    .prompt-row{
      .header{
        text-align: center;
        color: $red-2;
        font-weight: bold;
        padding-bottom: 1em;
      }
    }

    .exit-row {
      display: flex;
      justify-content: flex-end;
      .logout-button{
        cursor: pointer;
      }
    }

    .actions-row {
      display: flex;
      justify-content: center;
      flex-direction: column;
      .action {
        padding: 0.5em 0;
      }
    }
  }
</style>
